'use strict';

export default {
    
    Ping: 'Ping',

    TEXT: 'TEXT',
    QUOTED_TEXT: 'QUOTED_TEXT',
    DELETED_TEXT: 'DELETED_TEXT',
    FORM: 'FORM',
    FILE: 'FILE',
    INFO: 'INFO',
    LOCATION: 'LOCATION',
    CALL: 'CALL',
    USER: 'USER'
}